export default __webpack_public_path__ + "static/media/survivor.265c04f9.png";